import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

const Container = styled.div`
  padding: 1rem;
  background-color: #f0f4f8;
  text-align: left;
  border-radius: 5px;

  p, a {
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word; /* Optional fallback */
  }

  @media (max-width: 768px) {
    text-align: center;

    p {
      display: flex;
      flex-direction: column;
      font-size: 14px;
    }
  }
`;

const CategoryDetails = ({category}) => {
  const { i18n } = useTranslation();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const tokenString = sessionStorage.getItem("token");
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Container>
      <p><strong>{i18n.t('name')} (English):</strong> {category.name.en}</p>
      <p><strong>{i18n.t('name')} (Ελληνικά):</strong> {category.name.gr}</p>
      <p><strong>{i18n.t('description')} (English):</strong> {category.description.en}</p>
      <p><strong>{i18n.t('description')} (Ελληνικά):</strong> {category.description.gr}</p>
    </Container>
  )
}

export default CategoryDetails
